import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import "@arco-design/web-react/es/Avatar/style";
import _Avatar from "@arco-design/web-react/es/Avatar";
import "@arco-design/web-react/es/Tooltip/style";
import _Tooltip from "@arco-design/web-react/es/Tooltip";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import _IconNotification from "@arco-design/web-react/icon/react-icon/IconNotification";
import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import _IconLanguage from "@arco-design/web-react/icon/react-icon/IconLanguage";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Divider/style";
import _Divider from "@arco-design/web-react/es/Divider";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import { useContext, useEffect, useState } from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GlobalContext } from '@/context';
import useLocale from '@/utils/useLocale';
import Logo from '@/assets/logo.svg';
import MessageBox from '@/components/MessageBox';
import IconButton from './IconButton';
import Settings from '../Settings';
import styles from './style/index.module.less';
import defaultLocale from '@/locale';
import { getUserAvatarUrl, subscribeUserAvatarRefresh } from '@/utils/avatar';
function Navbar({
  show
}) {
  const t = useLocale();
  const history = useHistory();
  const userInfo = useSelector(state => state.userInfo);
  const [avatarToken, setAvatarToken] = useState(0);
  const {
    setLang,
    lang,
    theme,
    setTheme
  } = useContext(GlobalContext);
  useEffect(() => {
    return subscribeUserAvatarRefresh(token => {
      setAvatarToken(token);
    });
  }, []);
  function logout() {
    try {
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('token');
    } catch {}
    history.replace('/login');
  }
  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      history.replace('/personal');
    }
  }
  if (!show) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['fixed-settings']
    }, /*#__PURE__*/React.createElement(Settings, {
      trigger: /*#__PURE__*/React.createElement(_Button, {
        icon: /*#__PURE__*/React.createElement(_IconSettings, null),
        type: "primary",
        size: "large"
      })
    }));
  }
  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "setting"
  }, /*#__PURE__*/React.createElement(_IconSettings, {
    className: styles['dropdown-icon']
  }), t['menu.user.setting']), /*#__PURE__*/React.createElement(_Divider, {
    style: {
      margin: '4px 0'
    }
  }), /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), t['navbar.logout']));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, "\u7801\u4E0A\u89C6\u754C"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Input.Search, {
    className: styles.round,
    placeholder: t['navbar.search.placeholder']
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Select, {
    triggerElement: /*#__PURE__*/React.createElement(IconButton, {
      icon: /*#__PURE__*/React.createElement(_IconLanguage, null)
    }),
    options: [{
      label: '中文',
      value: 'zh-CN'
    }, {
      label: 'English',
      value: 'en-US'
    }],
    value: lang,
    triggerProps: {
      autoAlignPopupWidth: false,
      autoAlignPopupMinWidth: true,
      position: 'br'
    },
    trigger: "hover",
    onChange: value => {
      setLang(value);
      const nextLang = defaultLocale[value];
      _Message.info(`${nextLang['message.lang.tips']}${value}`);
    }
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(MessageBox, null, /*#__PURE__*/React.createElement(IconButton, {
    icon: /*#__PURE__*/React.createElement(_IconNotification, null)
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Tooltip, {
    content: theme === 'light' ? t['settings.navbar.theme.toDark'] : t['settings.navbar.theme.toLight']
  }, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Settings, null)), userInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement(_Avatar, {
    size: 32,
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("img", {
    alt: "avatar",
    src: getUserAvatarUrl(userInfo.userId, avatarToken)
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.username
  }, userInfo?.userName))))));
}
export default Navbar;